/*
 --------------------
 VIDEO PLAYER - AUDIO
 --------------------

 A single instance of an Audio-Only Brightcove Player. This player will only play Audio */

class audioOnlyPlayer {

  constructor(options, manager) {

    console.log(options);

    this.initialisePlayer = this.initialisePlayer.bind(this);
    this.identifyElements = this.identifyElements.bind(this);
    this.ima3FetchCallback = this.ima3FetchCallback.bind(this);
    this.ixFetchCallback = this.ixFetchCallback.bind(this);
    this.adtechReadyCallback = this.adtechReadyCallback.bind(this);
    this.modifyAdserverUrlWithTargeting = this.modifyAdserverUrlWithTargeting.bind(
      this
    );
    this.modifyAdserverUrlWithIxWrapper = this.modifyAdserverUrlWithIxWrapper.bind(
      this
    );
    this.allTechReadyGo = this.allTechReadyGo.bind(this);

    this.callbackPlay = this.callbackPlay.bind(this);
    this.callbackAudioEnded = this.callbackAudioEnded.bind(this);
    this.readyUpFrontend = this.readyUpFrontend.bind(this);
    this.callbackLoadMetadataFinished = this.callbackLoadMetadataFinished.bind(
      this
    );
    this.callbackAdsStarted = this.callbackAdsStarted.bind(this);
    this.callbackAdsEnded = this.callbackAdsEnded.bind(this);


    this.manager = manager;

    this.accountID = typeof (options.accountID !== 'undefined')
      ? options.accountID
      : false; // What is our Brightcove Account ID?

    this.adserverURL = typeof (options.adserverURL !== 'undefined')
      ? options.adserverURL
      : false; // What is the URL for the adserver?

    this.containerID = typeof (options.containerID !== 'undefined')
      ? options.containerID
      : false; // Which is the ID of the container in which the player is being initialised?

    this.playerElementID = typeof (options.playerElementID !== 'undefined')
      ? options.playerElementID
      : false; // Which is the ID of the container in which the player is being initialised?

    this.playerID = typeof (options.playerID !== 'undefined')
      ? options.playerID
      : false; // Which is the Brightcove ID of the player?

    this.audioID = typeof (options.audioID !== 'undefined')
      ? options.audioID
      : false; // Which specific audio track is being loaded in?

    this.adFrequency = typeof (options.adFrequency !== 'undefined')
      ? options.adFrequency
      : false;  // How often (in seconds) will the player pause playback and initiate an ad?

    this.playerReadyCallback = typeof (options.playerReadyCallback === 'function')
      ? options.playerReadyCallback
      : false;  // Callback to call when the player is ready to play content



    this.elementContainer = document.querySelector("#" + this.containerID);
    this.elementPlayer = document.querySelector("#" + this.playerElementID);


    this.player = {}; // The Brightcove player object
    // this.playlist = false; // The Brightcove playlist object

    this.ima3ScriptAvailable = false; // Set to true once ima3 script has loaded
    this.adtechReady = false; // Set to true once header bidder has had chance to modify URL

    this.ixScriptAvailable = false; // Set to true once IX script has loaded
    this.initialised = false; // Set to true once the player has begun initialisation



    if (typeof this.audioIDs === 'undefined' || this.audioIDs === false) {
      this.audioIDs = [];
    }

    if (typeof this.audioID !== 'undefined' && this.audioID) {
      this.audioIDs.unshift(this.audioID);
    }




    // Ensures BC script is properly fetched
    const bCScriptFetched = new Promise(resolve => {
      const identifier = this.playerID + this.accountID;
      const scriptFetched = manager.isScriptFetched(identifier);
      if (scriptFetched) {
        resolve();
      } else {
        manager.fetchBCScript(this.accountID, this.playerID, resolve);
      }
    });

    bCScriptFetched.then(() => {
      // Give the wrapper 4000ms to init all required tech once bc script is fetched. If it's still not available, then start the player without it
      setTimeout(() => {
        if (this.initialised === false) {
          console.log('triggering audio player fallback timer');
          this.initialisePlayer();
        }
      }, 4000);
      const scriptFetched = manager.isScriptFetched('ima3');
      manager.fetchIMA3Script(this.ima3FetchCallback);
      // if (scriptFetched) {
      //   this.ima3FetchCallback();
      // } else {
      //   manager.fetchIMA3Script(this.ima3FetchCallback);
      // }
    });
  } // End constructor


  /* =========================================
     ADTECH INIT
     =========================================
   */


  ixFetchCallback() {
    this.ixScriptAvailable = true;
    this.allTechReadyGo();
  }

  // Script to callback once IMA3 script is fetched. This will initialise the player
  ima3FetchCallback() {
    console.log("RUNNING METHOD ima3FetchCallback!");
    this.ima3ScriptAvailable = true; // Mark script as retrieved
    this.allTechReadyGo();
  }

  // Callback which fires when adtech has modified the adserver URL
  adtechReadyCallback() {
    if (!this.adtechReady) {
      this.modifyAdserverUrlWithTargeting();
    }
    this.adtechReady = true;
    this.allTechReadyGo();
  }

  allTechReadyGo() {
    if (this.initialised === true) return;
    // if (this.adtechReady === false) return;
    if (this.ima3ScriptAvailable === false) return;
    // if (this.ixScriptAvailable === false) return;
    // this.modifyAdserverUrlWithIxWrapper();
    this.initialisePlayer();
  }

  // TODO - Verify that this works correctly
  modifyAdserverUrlWithTargeting() {
    if (typeof window.AdManager === 'undefined') return;

    const globalTargeting = window.AdManager.globalTargeting;
    // let adParams = '';
    let queryString = Object.keys(globalTargeting)
      .map(
        key =>
          `${encodeURIComponent(key)}%3D${encodeURIComponent(
            globalTargeting[key]
          )}`
      )
      .join('%26');

    if (queryString.length > 0) {
      queryString = `%26${queryString}`;
    }

    this.adserverURL += queryString;
  }

  // Modifies the Adserver URL so that it is wrapped in IX Tags
  modifyAdserverUrlWithIxWrapper() {
    if (
      typeof window.getIndexTag === 'function' &&
      typeof window.indexConfig !== 'undefined'
    ) {
      this.adserverURL = window.getIndexTag(
        this.adserverURL,
        window.indexConfig
      );
    }
  }


  /* =========================================
     MAIN PLAYER INIT
     =========================================
   */


  // Link the Brightcove player to the Audio Element, and initialise all listeners, events, etc
  initialisePlayer() {
    // TODO - INIT
    this.initialised = true;
    console.log('initialise player run');

    this.player = window.bc(this.playerElementID);
    this.player.ima3({
      adTechOrder: ['html5'],
      timeout: 5000,
      requestMode: 'onload',
      hardTimeouts: false,
      serverUrl: this.adserverURL,
      vpaidMode: 'ENABLED',
      debug: false,
      useMediaCuePoints: false,
    });

    // Define player-based event listeners
    this.player.on('ima3-ad-error', e => this.callbackAdsFailed(e));
    this.player.on('ads-request', this.callbackAdsRequested);
    this.player.on('ads-ad-started', this.callbackAdsStarted);
    this.player.on('ads-ad-ended', this.callbackAdsEnded);
    this.player.on('ads-pod-ended', this.callbackAdsEnded);
    this.player.on('play', this.callbackPlay);
    this.player.on('loadstart', this.callbackLoadMetadataStart);
    this.player.on('loadedmetadata', this.callbackLoadMetadataFinished);
    this.player.on('ended', this.callbackAudioEnded);

    this.player.one('play', this.callbackFirstTimePlay);
    this.player.one('canplay', this.callbackFirstTimeIsPlayable);

    this.player.on('ended', this.callbackAudioEnded);

    this.player.on('loadedmetadata',this.playerReadyCallback);


    //TODO move this to above
    this.player.on('ads-load', () => {
      console.log('AUDIO PLAYER - ads loaded');
      const playerContainer = document.getElementById("po-audio-player__brightcove-container");
      playerContainer.style.height = "100%";
      document.getElementById('modal-container').classList.add('four');
    });

    this.player.on('ads-ad-ended', () => {
      console.log('AUDIO PLAYER - ads ended');
      document.getElementById("po-audio-player__brightcove-container").style.height = "1px";
      document.getElementById('modal-container').classList.remove('four');
      document.getElementById('modal-container').classList.add('out');
    });

    this.player.on('progress', () => {
      console.log('AUDIO PLAYER - radio playing');
      document.getElementById("po-audio-player__brightcove-container").style.height = "1px";
    });

    this.fetchAudio();
  }

  // Final method to be called once processing is done. Populates relevant divs, hides unnecessary ones, etc
  readyUpFrontend() {
    // this.player.play();
  }

  // Show error messages for failed audio load
  failUpFrontend() {
    console.log('failed to load audio player due to lack of media');
  }



  /* =========================================
     MEDIA FETCH METHODS
     =========================================
   */


  // Fetch audios from Brightcove
  fetchAudio() {
    console.log("RUNNING FETCH AUDIO");
    this.player.catalog.getVideo(this.audioID, (error, audio) => {
      if (error) {
        console.log("CANNOT FIND AUDIO");
        console.log(error);
        this.failUpFrontend();
      } else {
        console.log("FETCHED AUDIO");
        this.player.catalog.load(audio);
        this.readyUpFrontend();
      }
    });
  }

  /* =========================================
     CUSTOM CONTROLS
     =========================================
   */






  /* =========================================
     CALLBACKS
     =========================================
   */

  // Callback which fires once all audios requested have been fetched


  // Callback which fires when BC triggers an ads requested event
  callbackAdsRequested() {
    console.log("ADS REQUESTED FOR AUDIO PLAYER!");
  }

  // Callback which fires when BC triggers an ads started event
  callbackAdsStarted() {
    console.log("CALLBACK ADS STARTED FIRED");
    // NOTE - Don't pause the main player. This causes issues on iOS devices.
  }

  // Callback which fires when BC triggers an ads ended event
  callbackAdsEnded() {
    console.log("CALLBACK AD ENDED");
    const promise = this.player.play();
    if (promise !== undefined) {
      promise.then(_ => {
        console.log("AUTOPLAY STARTED!");
        // Autoplay started!
      }).catch(error => {
        console.log("CALLBACK ADS END ERROR CATCH");
        this.player.play();
      });
    }
  }

  // Callback which fires when the IMA3 plugin identifies that an ad has failed to load
  callbackAdsFailed(e = false) {
    console.log('AD ERROR FIRED');
    console.log(e);
    // TODO - Need to implement a recover method to force-quit ima3
  }

  // Callback which fires when BC starts the selected audio
  callbackPlay() {
    console.log("CALLBACK PLAY FIRED");
  }

  // Callback which fires the very first time BC starts a audio. Will not fire twice in one pageview
  callbackFirstTimePlay() {}

  // Callback which fires when BC begins loading metadata
  callbackLoadMetadataStart() {}

  // Callback which fires when BC finishes loading metadata
  callbackLoadMetadataFinished() {}

  // Callback which fires when BC determines that the initial audio is playable.
  callbackFirstTimeIsPlayable() {
    if(!this.playerReadyCallback) return;
    this.playerReadyCallback();
  }

  // Callback which fires when the selected audio finishes playing (reaches its end time)
  callbackAudioEnded() {
    console.log("CALLBACK AUDIO ENDED FIRED");
  }



  /* =========================================
     ELEMENT IDENTIFICATION
     =========================================
   */

  // Modify the divs already on the page with Brightcove data
  identifyElements() {}

}

export default (options, manager) => new audioOnlyPlayer(options, manager);